module.exports = __webpack_public_path__ + "static/img/bass.294de23.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fx-software/pack/bass.png
// module id = kiGX
// module chunks = 12